import { render, staticRenderFns } from "./modalWordStats.vue?vue&type=template&id=16f32926&"
import script from "./modalWordStats.vue?vue&type=script&lang=js&"
export * from "./modalWordStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports